import { createGlobalStyle } from 'styled-components';
import * as styledVars from '@capillarytech/cap-ui-library/styled/variables';

const { CAP_SPACE_04, CAP_SPACE_40, FONT_COLOR_01, FONT_COLOR_04 } = styledVars;

const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
    font-family: 'Roboto', Arial, sans-serif;
    font-size: 14px;
    line-height: unset;
  }

  body.fontLoaded {
    font-family: 'Roboto', Arial, sans-serif;
  }

  #intouch-app {
    min-height: 100%;
    min-width: 100%;

    .cap-navigation-spa__main {
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  p,
  label {
    font-family: 'Roboto', Arial, sans-serif;
    line-height: 1.5em;
  }

  .intouch-ui-app-body {
    .ant-popover,
    .ant-select-dropdown,
    .ant-select-dropdown.ant-select-dropdown--single,
    .ant-calendar-picker-container,
    .ant-notification,
    .ant-tooltip,
    .ant-modal-mask,
    .ant-modal-wrap {
      z-index: 10003; /* setting z-index, to be able to show the contect on top of slidebox */
    }
    .cap-popover-v2.version-history-popup {
      .ant-popover-inner-content {
        max-height: 350px;
        overflow-y: auto;
        min-width: 200px;
        .extension-version-history {
          .extension-details-heading-margin-top {
            margin-bottom: 6px;
          }
          & > .cap-row-v2 {
            margin-bottom: 3px;
            .ant-col-13.cap-column-v2 {
              div {
                display: inline-block;
                vertical-align: revert;
              }
            }
          }
          & > .cap-row-v2.enabled {
            font-weight: 700;
          }
        }
      }
    }
    .cap-modal-v2.extension-popup-container-modal {
      max-width: 550px;
      .ant-modal-content {
        .ant-modal-body {
          padding: 20px;
          .icon-message-container {
            width: 100%;
            .message-container {
              margin-left: 6px;
              width: 80%;
              padding: 4px 10px;
              .go-to-extension-link-container {
                margin-top: 16px;
                .ant-anchor {
                  padding: 0;
                  .ant-anchor-link-title {
                    .cap-icon-v2 {
                      vertical-align: initial;
                      margin-left: 4px;
                    }
                  }
                }
              }
              .header {
                font-size: 14px;
                font-weight: 500;
              }
              .api-details {
                margin-top: 8px;
                div[type="h4"], div[type="label18"] {
                  display: inline-block;
                  margin-right: 6px;
                }
              }
            }
            .icon-container {
              width: 10%;
              padding: 0 7px;
              .cap-icon-v2 {
                font-size: 36px;
                vertical-align: middle;
                color: #F2C037;
              }
            }
          }
        }
        .ant-modal-footer {
          display: none;
        }
      }
    }
    /* Activate / deactivate confirmation modal shared by the concept and till
       listings. Styled here (not inline) because the modal is portaled out of
       the component tree, so component-scoped styles can't reach it. */
    .cap-modal-v2.entity-status-modal {
      .ant-modal-title {
        font-size: 20px;
        font-weight: 600;
        color: #1a1a1a;
      }
      .ant-modal-body {
        font-size: 14px;
        color: #5e6b7e;

        p {
          margin: 0;
        }
      }
      .ant-modal-footer {
        text-align: left;

        /* The confirm action (danger "Yes, deactivate" / primary
           "Yes, activate") renders solid, so its label must be white. */
        .ant-btn-primary {
          color: #fff;
        }
      }
    }
    .cap-modal-v2.extension-upload-popup-container-modal {
      max-width: 550px;
      .ant-modal-content {
        .ant-modal-body {
          padding: 30px 30px 0px 30px;
        }
      }
      .cap-csv-file-uploader {
        .csv-fileipload-container {
          div.file-upload {
            margin: 12px 6px;
          }
          a {
            vertical-align: top;
            display: inline-block;
            margin-top: 17px;
            margin-left: 8px;
          }
        }
        .cap-tag-v2 {
          margin-top: 15px;
        }
      }
    }
  }
  
  
  ul, ol {
    list-style: none;
    padding: 0;
  }

  .pointer-cursor {
    cursor: pointer;
  }

  .truncate-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .align-items-center, div.align-items-center {
    display: flex;
    align-items: center;
  }

  .slide-box-size-medium{
    width: 660px;
  }

  // For Loadable Spin
  &.ant-spin.ant-spin-spinning {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }


  .confirm-publish-version-modal {
    .ant-modal-footer {
      padding-bottom: 16px;
    }
    .modal-btn-row {
      margin-right: 6px;
    }
  }

  .ant-row.ant-row-flex,
  .ant-row.ant-row-space-between,
  .ant-row.ant-row-space-around,
  .ant-row.ant-row-space-evenly {
    width: 100%;
  }
  .ant-spin-nested-loading {
    width: 100%;
  }
`;

export default GlobalStyle;
